module.exports = __webpack_public_path__ + "img/release_risk_bg1.717a5e04.jpg";